import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import IconAssetsRouter from './IconAssetsRouter';

function IconRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <Redirect to={`${routes.ICONS}/${routes.ASSETS}`} />
                </Route>
                <Route path={`${path}/${routes.ASSETS}`}>
                    <IconAssetsRouter />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default IconRouter;
